import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useDispatch } from "react-redux"; 

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import SourcingCommonFilter from "../../../Components/Filter/Sourcing/SourcingCommonFilter";
import {
  validateEmail,
  validateContactNumber,
  validateRequired,
} from "../../../common/Validations";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import { MultiselectField } from "../../../Components/formElements/MultiselectField";


//Serivce
import ItemService from "../../../services/supplier_appCommonService";
import toast from "react-hot-toast";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import Constants from "../../../common/SupplierConstants";
import { getUsersListData } from "../../../redux/feature/userSlice";

const ManageAddUser = () => {
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Admin");
  localStorage.setItem("submenu", "");

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [getDropdownData, setDropdownData] = useState("");

  const modalData = {
    title: "User Creation",
    successMsg: "",
  };
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);

  const [disabled, setDisabled] = useState(false);
  const [getApplicationMasterVal, setApplicationMasterVal] = useState("");
  const [getCategoryVal, setCategoryVal] = useState([]);
  const [getSubCategoryVal, setSubCategoryVal] = useState([]);
  const [getRoleIdVal, setRoleIdVal] = useState([]);

  const [formInputs, setFormInputs] = useState({
    status: "On Boarded",
    tenant: "",
    customerId: "",
    customerName: "",
    userId: "",
    firstName: "",
    lastName: "",
    password: "",
    email: "",
    contactNumber: "",
    companyName: "",
    category: "",
    subCategory: "",
    roles: "",
  });

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  /* Add User Button */
  const handleAddUser = async () => {
    let requiredFields = [];

    if (
      !validateRequired(formInputs?.userId) ||
      !validateRequired(formInputs?.firstName) ||
      !validateRequired(formInputs?.email) ||
      !validateRequired(formInputs?.contactNumber)
    ) {
      requiredFields.push("*Please Enter User Id");
      requiredFields.push("*Please Enter First Name");
      requiredFields.push("*Please Enter Email");
      requiredFields.push("*Please Enter Contact Number");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    if (!validateEmail(formInputs?.email)) {
      requiredFields.push("*Invalid Contact Email address");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    if (!validateContactNumber(formInputs?.contactNumber)) {
      requiredFields.push("*Invalid contact number (10 digits)");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    formInputs.tenant = getApplicationMasterVal.tenant;
    formInputs.customerId = getApplicationMasterVal.customerId;
    formInputs.customerName = getApplicationMasterVal.customerName;

    console.log(">> handleAddUser", formInputs);

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    let obj = {
      data: formInputs,
    };
    setDisabled(true);
    await ItemService.addUser(obj).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        // Update response value in Redux Store
        dispatch(getUsersListData()); // event store
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // Get Dropdown data select
  useEffect(() => {
    // console.log(">> getDropdownData >> ", getDropdownData);

    if (getDropdownData?.textField === "category") {
      getSubCategory(getDropdownData?.name); // get Sub Category List

      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "subCategory") {
      let objArr = [];
      let objForApi = [];
      getDropdownData?.selected?.map((item, index) => {
        objArr.push({
          categoryId: item.name,
          active: true,
        });

        objForApi.push(item.name);
        return "";
      });

      getSubCategoryRoleId(objForApi); // get SubCategory Role Id List

      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: objArr,
      }));
    } else if (getDropdownData?.textField === "roles") {
      let objArr = [];
      getDropdownData?.selected?.map((item, index) =>
        objArr.push({
          roleId: item.name,
        })
      );
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: objArr,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.selected,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const [getFailureModal] = useState(failureModalData);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  //on page load
  useEffect(() => {
    getApplicationMaster();
    getCategory();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCategory = async () => {
    let obj = {};
    await ItemService.getCategory(obj).then((item) => {
      if (item?.status === 200) {
        setCategoryVal(item?.data);
      } else {
        setCategoryVal([]);
        console.log(">> Error: Loading getCategory");
      }
    });
  };

  const getSubCategory = async (param) => {
    let obj = {
      category: param,
    };
    await ItemService.getSubCategory(obj).then((item) => {
      if (item?.status === 200) {
        setSubCategoryVal(item?.data);
        setRoleIdVal([]);
      } else {
        setSubCategoryVal([]);
        console.log(">> Error: Loading getSubCategory");
      }
    });
  };

  const getSubCategoryRoleId = async (param) => {
    // console.log(">> Role param", param);
    let obj = {
      subCategories: param,
    };
    await ItemService.getSubCategoryRoleId(obj).then((item) => {
      if (item?.status === 200) {
        setRoleIdVal(item?.data);
      } else {
        setRoleIdVal([]);
        console.log(">> Error: Loading getSubCategoryRoleId");
      }
    });
  };

  const getApplicationMaster = async () => {
    let obj = {};
    await ItemService.getApplicationMaster(obj).then((item) => {
      // console.log(">> item! getApplicationMaster", item);
      if (item?.status === 200) {
        setApplicationMasterVal(item?.data[0]);
      } else {
        setApplicationMasterVal([]);
        console.log(">> Error: Loading getApplicationMaster");
      }
    });
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={10} lg={10} className="mb-2">
                <h2 className="mainTitle">Add User</h2>
                <p className="subText">Add User to User's Collection</p>
              </Col>
              <Col xs={12} md={2} lg={2} className="mb-2">
                <button
                  className="btn w-full"
                  onClick={handleAddUser}
                  disabled={disabled}
                >
                  Create User
                </button>
              </Col>
              <hr />
            </Row>

            {/* add user */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AU</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Enter User Details</span>
                      <span className="subHeaderTitle">Enter User Details</span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tenant"
                          name="tenant"
                          placeholder=""
                          value={getApplicationMasterVal.tenant || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status"
                          name="status"
                          placeholder=""
                          value={formInputs.status || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer ID"
                          name="customerId"
                          placeholder=""
                          value={getApplicationMasterVal.customerId || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Name"
                          name="customerName"
                          placeholder=""
                          value={getApplicationMasterVal.customerName || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="User ID"
                          name="userId"
                          placeholder=""
                          value={formInputs.userId || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="First Name"
                          name="firstName"
                          placeholder=""
                          value={formInputs.firstName || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Last Name"
                          name="lastName"
                          placeholder=""
                          value={formInputs.lastName || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Password"
                          name="password"
                          placeholder=""
                          value={formInputs.password || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Email"
                          name="email"
                          placeholder=""
                          value={formInputs.email || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Contact Number"
                          name="contactNumber"
                          placeholder=""
                          value={formInputs.contactNumber || ""}
                          onChange={onInputChange}
                          maxLength="10"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="companyName"
                          placeholder=""
                          value={formInputs.companyName || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Category"
                          placeholder="Please select the Category"
                          data={getCategoryVal}
                          id="category"
                          iconClassName="dropdownIcon"
                          name="category"
                          setValue={formInputs.category}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="Sub Category"
                          placeholder="Please select the Sub Category"
                          data={getSubCategoryVal}
                          id="subCategory"
                          iconClassName="dropdownIcon"
                          name="subCategory"
                          getvalue={setDropdownData}
                          className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="Roles"
                          placeholder="Please select the Roles"
                          data={getRoleIdVal}
                          id="roles"
                          iconClassName="dropdownIcon"
                          name="roles"
                          getvalue={setDropdownData}
                          className="dropdownOption"
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.ADMIN_MANAGE_USER_LIST}
      />
    </main>
  );
};

export default ManageAddUser;
